export default "__VITE_ASSET__BHXbqO4$__"